import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUnreadApplication } from "sr/utils/api/cleaner/getUnreadApplication";

export const fetchCompanyChat = createAsyncThunk('companychat', async (params:any)=> {
    const queryParams = new URLSearchParams()
        queryParams.append('company_id', params?.companyId)
        const res = await getUnreadApplication(queryParams)
    try {
                    if(res?.success===true) {
                   
                    return res?.data;
                    }
    }
    catch(e:any){

    }

})

interface initialState  {
    isError:Boolean,
    data:any,
    isLoading:any
}
const initialState:initialState = {
    isError:false,
    data:null,
    isLoading:false
}
const companyChatSlice = createSlice({
    name:'companyChat',
    initialState,
    extraReducers:(builder)=> {
        builder.addCase(fetchCompanyChat.pending, (state, action)=> {
            state.isLoading = true
        })
        builder.addCase(fetchCompanyChat.fulfilled, (state, action)=> {
            state.data = action.payload
        })
        builder.addCase(fetchCompanyChat.rejected, (state, action)=> {
            state.isError = true
        })
    },
    reducers:{updateUnreadChatCount:(state, action)=> {
        if(state?.data===null){
            state.data = []
        }
        
        const getActionJobId = (c: any) => typeof c?.job_id === 'string' ? c?.job_id : (c?.job_id?._id || c?.job_id?.id);
        const getActionSenderId = (c: any) => typeof c?.sender_id === 'string' ? c?.sender_id : (c?.sender_id?._id || c?.sender_id?.id);
        const getItemJobId = (c: any) => typeof c?.job_id === 'string' ? c?.job_id : (c?.job_id?._id || c?.job_id?.id);
        const getItemCleanerId = (c: any) => typeof c?.cleaner_id === 'string' ? c?.cleaner_id : (c?.cleaner_id?._id || c?.cleaner_id?.id);
        const getItemSenderId = (c: any) => typeof c?.sender_id === 'string' ? c?.sender_id : (c?.sender_id?._id || c?.sender_id?.id);

        const newjob = state?.data?.some((item: any) => 
            (getItemJobId(item) === getActionJobId(action.payload)) && 
            (getItemCleanerId(item) === getActionSenderId(action.payload) || getItemSenderId(item) === getActionSenderId(action.payload))
        );

        if(!newjob){
            state.data = [...state?.data, action.payload]
        }
    },
    removeUnreadChatCount: (state, action) => {
        if (state.data) {
            const getJobId = (c: any) => typeof c?.job_id === 'string' ? c?.job_id : (c?.job_id?._id || c?.job_id?.id);
            const getActionJobId = (c: any) => typeof c?.job_id === 'string' ? c?.job_id : (c?.job_id?._id || c?.job_id?.id);
            
            const getCleanerId = (c: any) => typeof c?.cleaner_id === 'string' ? c?.cleaner_id : (c?.cleaner_id?._id || c?.cleaner_id?.id);
            const getActionCleanerId = (c: any) => typeof c?.cleaner_id === 'string' ? c?.cleaner_id : (c?.cleaner_id?._id || c?.cleaner_id?.id);
            
            state.data = state.data.filter((item: any) => {
                const sameJob = getJobId(item) === getActionJobId(action.payload);
                const actionCleaner = getActionCleanerId(action.payload);
                const sameCleaner = !actionCleaner || getCleanerId(item) === actionCleaner;
                return !(sameJob && sameCleaner);
            });
        }
    }}
})
export default companyChatSlice.reducer;
export const {updateUnreadChatCount, removeUnreadChatCount} = companyChatSlice.actions